import { createElement, ElementType } from "react";
import { tokenDefKeyToCssVar } from "@/lib/design-token-utils";
import { size, Size, spacing, Spacing } from "@/lib/design-tokens";

type FlexDirection = React.CSSProperties["flexDirection"];

type FlexProps = {
  direction?: FlexDirection;
  justify?: React.CSSProperties["justifyContent"];
  align?: React.CSSProperties["alignItems"];
  gap?: Spacing;
  width?: Size;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  as?: ElementType;
} & React.HTMLAttributes<HTMLElement>;

const Flex: React.FC<FlexProps> = ({
  direction = "row",
  justify = "flex-start",
  align = "stretch",
  gap = "none",
  width = null,
  children,
  className,
  onClick,
  style,
  as: Component = "div",
  ...restProps
}) => {
  return createElement(
    Component,
    {
      style: {
        display: "flex",
        flexDirection: direction,
        justifyContent: justify,
        alignItems: align,
        gap: tokenDefKeyToCssVar(spacing, gap),
        width: width ? tokenDefKeyToCssVar(size, width) : undefined,
        ...style,
      },
      className,
      onClick,
      ...restProps,
    },
    children,
  );
};

export { Flex };
